<template>
    <div class="Vehicle" style="background-color:rgb(245,245,249);">
        <Gnb v-bind:gnbCode=gnbCode v-bind:loginInfo1=loginInfo1 v-bind:loginInfo2=loginInfo2 />
        <div style="width:100%;" class="d-flex flex-row "  >
            <Navs v-bind:navCode1=navCode1 v-bind:navCode2=navCode2 v-bind:NavList=NavList />
            <div class="mt-3" style="width:100%; background-color:rgb(245,245,249);">
                <PageCrumbs v-bind:pTitles=pTitles v-bind:pCrumbs=pCrumbs />
                <div class="content" style="width:100%;min-height:770px;padding:2px 15px; background-color:rgb(245,245,249);">
                    <SummeryCnt v-bind:scnt1=scnt1 v-bind:scnt2=scnt2  v-bind:scnt3=scnt3  v-bind:scnt4=scnt4 
                    v-bind:summeryTtile=summeryTtile  v-bind:summeryTtile1=summeryTtile1  v-bind:summeryTtile2=summeryTtile2  v-bind:summeryTtile3=summeryTtile3 v-bind:summeryTtile4=summeryTtile4  />
                    <v-card elevation="1" class="mt-3" >
                        <div class="d-flex pt-3" style="width:100%;">
                            <div class="d-flex text-left pa-0 pl-5 py-5 align-self-center" style="width:250px;font-size:13px;font-weight:600">Registration Date</div>
                            <div class="d-flex pr-5" style="width:100%;">
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-menu 
                                        ref="menu1"
                                        v-model="menu1"
                                        :close-on-content-click="false"
                                        :return-value.sync="s_date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="150px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field 
                                            v-model="s_date"
                                            append-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            single-line hide-details outlined dense
                                            class="d-flex align-self-center mt-0 pt-0"
                                            style="font-size:13px; "
                                            placeholder="Start Date"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="s_date" no-title scrollable :max="e_date">
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="menu1 = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="s_date_search(s_date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </div>
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-menu
                                        ref="menu2"
                                        v-model="menu2"
                                        :close-on-content-click="false"
                                        :return-value.sync="e_date"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="220px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field
                                            v-model="e_date"
                                            append-icon="mdi-calendar"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            single-line hide-details outlined dense
                                            class="align-self-center ma-0 pa-0"
                                            style="font-size:13px;width:190px;"
                                            placeholder="End Date"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="e_date" no-title scrollable :min="s_date" :max="date">
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="menu2 = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="e_date_search(e_date)">OK</v-btn>
                                        </v-date-picker>
                                    </v-menu>
                                </div>
                                <div class="d-flex" >
                                    <v-btn-toggle v-model="toggleMonthBtn" class="pt-4">
                                        <v-btn small class="ml-1" @click="setSchDate(1)">Today</v-btn>
                                        <v-btn small  @click="setSchDate(2)">1 Month</v-btn>
                                        <v-btn small  @click="setSchDate(3)">All</v-btn>
                                    </v-btn-toggle>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex" style="width:100%;">
                            <div class="d-flex text-left pa-0 pl-5 py-5 align-self-center" style="width:250px;font-size:13px;font-weight:600">Classification</div>
                            <div class="d-flex pr-5" style="width:100%;">
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-select style="font-size:13px;" class="align-self-center" v-model="schCountryCode" :items="countryList" item-text="info" item-value="vals" label="National" outlined dense single-line hide-details>
                                    </v-select>
                                </div>
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-select style="font-size:13px;" class="align-self-center" v-model="schfactoryCode" :items="factoryList" item-text="info" item-value="vals" label="Manufacturer" outlined dense single-line hide-details>
                                    </v-select>
                                </div>
                                <div class="d-flex pr-5" style="width:180px;">
                                    <v-select style="font-size:13px;" class="align-self-center" v-model="schAprvStatus" :items="approvalList" item-text="info" item-value="vals" label="Status" outlined dense single-line hide-details>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex" style="width:100%;">
                            <div class="d-flex text-left pa-0 pl-5 py-5 align-self-center" style="width:250px;font-size:13px;font-weight:600">Keyword</div>
                            <div class="d-flex" style="width:100%;">
                                <div class="d-flex pt-2 pr-auto" style="width:557px;">
                                    <v-text-field v-model="schText" outlined dense single-line hide-details small placeholder="Vehicle ID Number / VCU ID / MCU ID / Battery ID"></v-text-field>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex pb-5 justify-center" style="width:100%;">
                            <v-btn class="schClearBtn" small dark @click="searchFormReset()">Clear </v-btn>
                            <v-btn class="ml-2 schBtn" small dark @click="getList()">Search</v-btn>
                        </div>
                    </v-card>
                    <v-card elevation="1" class="mt-3">
                        <div class="d-flex flat pa-5" elevation="0" >
                            <div class="mr-auto align-self-center font-weight-bold text-subtitle-1" >Total <span class="listCnt">{{listTotalCnt}}</span></div>
                            <div class="pr-2">
                                <v-btn color="red" small outlined class="ml-2" @click="setAprvStatus('3')">Canceled</v-btn>
                                <v-btn color="accent" small  outlined class="ml-2" @click="setAprvStatus('1')">Ready</v-btn>
                                <v-btn color="indigo" small  outlined  class="ml-2" @click="setAprvStatus('2')">Completed</v-btn>
                            </div>
                        </div>
                        <div>
                            <table style="width:100%;" cellspacing="0" cellpadding="0" class="px-5">
                                <tr class="listHeader">
                                    <th><v-checkbox class="align-self-center pl-2 ma-0" hide-details color="white" dark @click="checkedAll" v-model="allSelected"></v-checkbox></th>
                                    <th>No</th>
                                    <th>National</th>
                                    <th>Agency</th>
                                    <th>Model</th>
                                    <th>Vehicle Identify Number</th>
                                    <th>Company</th>
                                    <th>contractor</th>
                                    <th>Status</th>
                                    <th>Registration Date</th>
                                </tr>
                                <tr v-for="(item, index) in ebikeList" :key="item.EBK_SEQ">
                                    <td class="rowList"><v-checkbox v-model="selectEbkSeq" class="align-self-center pl-2 ma-0" hide-details  :value=item.EBK_SEQ @click="selected()"></v-checkbox></td>
                                    <td class="rowList">{{(listTotalCnt - (page -1) * 10) - index}}</td>
                                    <td class="rowList">{{item.NAT_NAME}}</td>
                                    <td class="rowList">{{item.FAC_NAME}}</td>
                                    <td class="rowList">{{item.EBK_MODEL_NAME}}</td>
                                    <td class="rowList"><span style="color:#1976D2;cursor:pointer;" @click="viewInfo(item.EBK_SEQ)">{{item.EBK_IDTFY_NUMS}}</span></td>
                                    <!--<td class="rowList"><router-link :to="{ name: 'VehicleDetail', params: {ebkSeq:item.EBK_SEQ}}">{{item.EBK_IDTFY_NUMS}}</router-link></td>--> 
                                    <td class="rowList">{{item.CTR_USR_COMPANY_NAME}}</td>
                                    <td class="rowList">{{item.CTR_USR_NM}}</td>
                                   
                                    <td class="rowList">{{item.CTR_INFO}}</td>
                                    <td class="rowList">{{item.INS_DTM}}</td>
                                </tr>
                                <tr v-if="emptyFlag=='Y'">
                                    <td colspan="11" style="height:80px;">
                                        <div>no data</div>
                                    </td>
                                </tr>
                            </table>
                            <div class="pa2" v-if="listTotalCnt>0">
                                <div class="text-center mt-5">
                                    <!--
                                    <v-pagination v-model="page" :length="pagelength" @input="getPageList"></v-pagination>
                                    -->
                                     <Paging :currentPage="page" :totalPages="pagelength" :key="listTotalCnt" :totalCount="listTotalCnt" @onPageChange="onPageChange" />
                                </div>
                            </div>
                            <div class="d-flex justify-space-between dense pa-5">
                                <div class="pa2 pl-2 " ><v-btn class="excelBtn" dark @click="downExcel" >Excel Download</v-btn></div>
                                <div class="pa2 pr-2">
                                    <!--
                                    <v-btn color="green lighten-2" small dark class="ml-2">Excel Registration</v-btn>
                                    <v-btn color="primary" small dark class="ml-2" @click="registerVehicle">New Registration</v-btn>
                                    -->
                                </div>
                            </div>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>
        <Footer/>

        <!-- Alert Dialog / Save -->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="alertFlag" width="450">
                <v-card>
                    <v-card-title class="text-subtitle-2 pb-0 text-wrap d-flex flat" style="width:450px;">
                        <v-icon class='d-flex' style='color:red;'>mdi-alert </v-icon>
                        <span class="d-flex pl-3">{{alertText}}</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="alertFlag = false;regFlag='Y'">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!-- alert: not checked -->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="chkListFlag" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:red;'>mdi-alert </v-icon>
                        <span class="pl-3">Please select a vehicle </span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="chkListFlag = false">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        
        <!--<ErrorDialog v-on:childEvent="closeErrorDialog" />-->

        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncSuccess" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-check-circle </v-icon>
                        <span class="pl-3">It's been processed successfully</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="closeDialog('Success')">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>

        <!--asyncErrors-->
        <div class="text-center pb-0 mb-0" >
            <v-dialog v-model="asyncErrors" width="400">
                <v-card>
                    <v-card-title class="text-subtitle-1 pb-0">
                        <v-icon style='color:green;'>mdi-alert-circle </v-icon>
                        <span class="pl-3">It's been processed failed.</span>
                    </v-card-title>
                    <v-card-actions class="justify-end">
                        <v-btn color="primary" text @click="closeDialog('Error')">ok</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<style scoped>
    th {height:38px;}
    .rowList { padding:5px 0;}
</style>

<script>
import Gnb from '@/components/gnbComponent.vue'
import PageCrumbs from '@/components/pageCrumbs.vue'
import SummeryCnt from '@/components/summeryCnt.vue'
import Footer from '@/components/footerComponent.vue'
import Navs from '@/components/nav.vue'
import Paging from '@/components/paging.vue'

import dayjs from 'dayjs'

export default {
    name: 'VehicleRLS',
    components: { Gnb, Footer, SummeryCnt, Navs, PageCrumbs, Paging },

    data () {
        return {
            // login Info
            gnbCode:"1", loginInfo1: "", loginInfo2: "", loginInfo3: "",
            navCode1:2, navCode2:21, 
            // Page Title & Breadcrumbs
            pTitles: "Contract List",
            pCrumbs: [ { text: 'Home', disabled: true,}, { text: 'Vehicle', disabled: true,}, { text: 'Contract Management', disabled: true,}, { text: 'Contract List', disabled: false,}],
            NavList: [
              {
                items: [
                  { title: 'Vehicle List', nums:11, href:'/Vehicle', icons:'mdi-format-list-bulleted' },
                  { title: 'New Registration', nums:12, href:'/VehicleWrite', icons:'mdi-lead-pencil' },
                ],
                title: 'Vehicle Management', nums: '1'
              },
              {
                items: [
                  { title: 'Contract List',nums:21, href:'/VehicleRLS', icons:'mdi-format-list-bulleted' },
                  { title: 'New Contract Registration', nums:22, href:'/VehicleRLS2', icons:'mdi-lead-pencil' },
                ],
                title: 'Contract Management', nums: '2'
              },
            ], 
            // Summery title & Count
            scnt1:"0", scnt2:"0", scnt3:"0", scnt4:"0", summeryTtile:"등록현황", summeryTtile1:"Total", summeryTtile2:"Ready", summeryTtile3:"Completed", summeryTtile4:"Canceled",
            // List count & Pagination 
            listTotalCnt: 0, page: 0, pagelength:0, ebikeList:[],
            emptyFlag: 'Y',
            // Datepicker & Short button
            date: new Date().toISOString().substr(0, 10), 
            s_date: "", e_date: "", menu1: false, menu2: false,
            toggleMonthBtn:2,
            // Search form : select 
            countryList: [{info: 'Indonesia', vals: "ID"}, {info: 'korea', vals: "KR"}],
            factoryList: [{info: 'E3 용인 공장', vals: 1}],
            modelList: [{info:'Duex 7(E3 Blade)', vals:1}],
            approvalList: [{info: 'Completed', vals: 2}, {info: 'Canceled', vals: 3}, {info: 'Ready', vals: 1}],
            schCountryCode: "", schfactoryCode:"", schfModelNum:"", schAprvStatus:"", schText:"",
            // Checkbox
            selectEbkSeq:[], allSelected: false,
            // Async & Modify Result
            chkListFlag : false,  asyncErrors: false, asyncSuccess: false, alertFlag: false, alertText:"",
        }
    },
    
    beforeCreate() {
        let uuid = localStorage.getItem("e3MngID");
        let uauthcode = localStorage.getItem("e3MngCode"); 
        if(uuid != '' && uauthcode !='') {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "uid": uuid, "authCode": uauthcode})
            };
            fetch('https://api.e3bss.com/_APP/POC/validAuthUsr.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            })
            .then((json) => {
                if(json.result != "success") {
                    this.$router.replace('RequireLogin');
                } 
            }).catch(() => {
                //console.log(error);
                this.$router.replace('Error');
            });
        } else {
             this.$router.replace('RequireLogin');
        }
    },

    created() {
        this.loginInfo1=localStorage.getItem("e3MngID");
        this.loginInfo2=localStorage.getItem("e3MnglgDTM");
        this.loginInfo3=localStorage.getItem("e3MngCode");
        this.page = 1;
        this.getList(this.page);
        localStorage.removeItem('ebkSeq');
    },

    methods : {
        // datepicker 
        setSchDate(arg) {
            if(arg == 1) {
                this.s_date = new Date().toISOString().substr(0, 10);
                this.e_date = new Date().toISOString().substr(0, 10);
            } else if(arg == 2) {
                let now = new Date();
                this.s_date =  new Date(now.setMonth(now.getMonth() - 1));
                this.s_date = this.s_date.toISOString().substr(0, 10);
                this.e_date = new Date().toISOString().substr(0, 10);
            } else if(arg == 3) {
                this.s_date = '';
                this.e_date = '';
            }
        },

        // datepicker - sub
        s_date_search(v) {
            this.s_date = v;
            this.menu1 = false;
            this.$refs.menu1.save(v);
        },

        // datepicker - sub
        e_date_search(v) {
            this.e_date = v;
            this.menu2 = false;
            this.$refs.menu2.save(v);
        },

        // search form reset
        searchFormReset() {
            this.s_date=""; this.e_date="";
            this.schCountryCode=""; this.schfactoryCode="";  this.schfModelNum=""; this.schAprvStatus=""; this.schText="";
            this.page = 1;
            this.getList(this.page);
        },

        getPageList() {
            //console.log(this.page);
            this.getList(this.page);
        },

        // API Async 
        getList(page) {
            var requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "L"
                    , "page":page
                    , "schRLSStatus": this.schAprvStatus
                    , "schCountryCode": this.schCountryCode
                    , "schFactoryCode": this.schfactoryCode
                    , "schStartDate": this.s_date, "schEndDate": this.e_date
                    , "schText": this.schText 
                })
            };
            
            console.log(JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "L"
                    , "page":page
                    , "schRLSStatus": this.schAprvStatus
                    , "schCountryCode": this.schCountryCode
                    , "schFactoryCode": this.schfactoryCode
                    , "schStartDate": this.s_date, "schEndDate": this.e_date
                    , "schText": this.schText 
                }));
            
            fetch('https://api.e3bss.com/_APP/POC/eBikeRLS.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                console.log(json );
                //console.log(json.value.list );
                if(json.result == "success") {
                    this.ebikeList =[];
                    this.ebikeList = json.value.list;
                    this.listTotalCnt = Number(json.totalCnt);
                    this.pagelength = json.totalPage;
                    this.page = json.currentPage;
                    this.emptyFlag = "N";
                } else {
                    this.ebikeList = [];
                    this.emptyFlag = "Y";
                    this.listTotalCnt = 0;
                    this.pagelength = 0;
                    this.page = 0;
                }
                this.scnt1 = json.cnt1; this.scnt2 = json.cnt2; this.scnt3 = json.cnt3; this.scnt4 = json.cnt4;
            }).catch((error) => {
                console.log(error);
                //this.$router.replace('Error');
                this.ebikeList = [];
                    this.emptyFlag = "Y";
                    this.listTotalCnt = 0;
                    this.pagelength = 0;
                    this.page = 0;
            });
        },

        // Approve Status Modify
        setAprvStatus(vals) {
            //console.log(this.selectEbkSeq.length + "/"+ this.selectEbkSeq);
            if(vals != '' && this.selectEbkSeq.length > 0) {
                this.chkListFlag = false;
                this.modifyApprove(vals);
            } else {
                this.chkListFlag = true;
            }
        },

        // API Async: Status Update
        modifyApprove(arg) {
            var  requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "LU"
                    , "ebkSeqArr": this.selectEbkSeq
                    , "ebkCtrStatus": arg
                })
            };
            /*
            console.log(JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "LU"
                    , "ebkSeqArr": this.selectEbkSeq
                    , "ebkCtrStatus": arg
                }));
            */
            fetch('https://api.e3bss.com/_APP/POC/eBikeRLS.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            }).then((json) => {
                console.log(json);
                if(json.result == "success") {
                    this.getList(1);
                    this.asyncSuccess = true;
                    this.asyncErrors = false;
                } else {
                    this.asyncSuccess = false;
                    this.asyncErrors = true;
                }
            }).catch(() => {
                this.asyncErrors = true;
                //console.log(error);
            });
        }, 

        registerVehicle() {
            if(this.selectEbkSeq.length > 1 || this.selectEbkSeq.length < 1) {
                //console.log("chk")
                this.alertFlag=true;
                this.alertToForm('2', 'One Vehicle');
                //return;
            } else {
                var tseq = this.selectEbkSeq.toString();
                this.$router.push({ name: 'VehicleRlsWrite', params: { ebkSeq: tseq, asyncActType: "C" }})
            }  
        },

        alertToForm(arg1, arg2) {
            var str1 = "enter";
            var strInfo1 = "Please"; var strInfo2 = "information";
            if(arg1 == 2) str1 = 'select';
            this.alertText = strInfo1 +' '+ str1 +' '+ arg2 +' '+ strInfo2+".";
        },
        
        viewInfo(arg) {
            localStorage.setItem('ebkSeq', arg);
            this.$router.push({ name: 'VehicleRlsDetail', params: { ebkSeq: arg }})
        },

        checkedAll() {
            //console.log('click');
            this.selectEbkSeq = [];
            if (this.allSelected) {
                for (let ebkies in this.ebikeList) {
                    this.selectEbkSeq.push(this.ebikeList[ebkies].EBK_SEQ.toString());
                }
            }
        },

        selected() {
            this.allSelected = false;
            //console.log(this.selectEbkSeq);
        }, 
        
        closeDialog(cls) {
            if(cls == "Success") {
                this.asyncSuccess = false;
            } else if(cls == "Error") {
                this.asyncErrors = false;
            }
            
            this.selectEbkSeq = [];
            this.allSelected=false;
        },
        
        onPageChange(param) {
            //console.log("onPageChange="+param);
            this.page = Number(param);
            //console.log("this.page="+Number(this.page));
            this.getList(this.page);
        },

        downExcel() {
            const xlsx = require("xlsx");
            // 엑셀 파일 생성
            const sheets = xlsx.utils.book_new();
            // data get > 실 개발시 api 호출
            
            var requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode": this.loginInfo3
                    , "act": "EL"
                    , "schRLSStatus": this.schAprvStatus
                    , "schCountryCode": this.schCountryCode
                    , "schFactoryCode": this.schfactoryCode
                    , "schStartDate": this.s_date, "schEndDate": this.e_date
                    , "schText": this.schText 
                })
            };
            /*
            console.log(JSON.stringify({ "usrID": this.loginInfo1
                    , "authCode":this.loginInfo3
                    , "act": "EL"
                    , "schRLSStatus": this.schAprvStatus
                    , "schCountryCode": this.schCountryCode
                    , "schFactoryCode": this.schfactoryCode
                    , "schStartDate": this.s_date, "schEndDate": this.e_date
                    , "schText": this.schText 
                }));
            */
            fetch('https://api.e3bss.com/_APP/POC/eBikeRLS.php', requestOptions)
            .then((response) => {
                if(response.ok) {
                    return response.json();
                }
                throw new Error('Network response was not ok');
            })
            .then((json) => {
                //console.log(json );
                //console.log(json.list );
                if(json.result == "success") {
                    const excelData = json.value.list;
                    const worksheetData = xlsx.utils.json_to_sheet(excelData);
                    xlsx.utils.book_append_sheet(sheets, worksheetData, "Data");
                    let nowDTM =  dayjs().format("YYYYMMDDHHmmss");
                    xlsx.writeFile(sheets, "vehicleReleaseList_"+nowDTM+".xlsx");
                } else {
                   alert("Error");
                   //this.$router.replace('Error');
                }
                
            }).catch((error) => {
                console.log(error);
                this.$router.replace('Error');
            });
           
        },

    }

}
</script>
